export default "__VITE_ASSET__DRgBbZt0__"